<script setup>
import { computed } from 'vue';

const props = defineProps({
    price: {
        type: Number,
        required: true,
    },
    appendage: {
        type: String,
        default: '',
    },
});

const formattedPrice = computed(() => {
    const absPrice = Math.abs(props.price);

    // Split into euros and cents
    const euros = Math.floor(absPrice);
    const cents = Math.round((absPrice - euros) * 100);

    // Handle rounding that causes cents to become 100
    if (cents === 100) {
        return {
            euros: props.price < 0 ? -(euros + 1) : euros + 1,
            cents: 0,
        };
    }
    const centsStr = cents.toString().padStart(2, '0');

    return {
        euros: props.price < 0 ? -euros : euros,
        cents: centsStr,
    };
});

</script>

<template>
    <div class="formatted-price">
        <span class="euro"> €&nbsp;{{ formattedPrice.euros }}</span>
        <span class="cent">,{{ formattedPrice.cents }}</span>
    </div>
</template>
